import React from 'react'
import FileRow from './file-row'
import styled from 'styled-components'
import ChevronDownIcon from './icons/chevron-down'
import ChevronUpIcon from './icons/chevron-up'

const MAX_NUMBER_OF_FILES = 3

const ShowAllToggleElement = styled.span`
  text-decoration: none;
  font-weight: 200;
  color: #78787b;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  line-height: 1rem;
  gap: 3px;
  width: fit-content;
  margin: 0;
  margin-top: 0.5rem !important;

  &:hover {
    color: #2e8ab8;
  }
`

function ArchivedFiles({ documentId, files }) {
  const [showAll, setShowAll] = React.useState(false)

  const filesToShow = showAll ? files : files.slice(0, MAX_NUMBER_OF_FILES)

  return (
    <>
      {filesToShow.map((file) => (
        <FileRow key={file.rid} file={file} documentId={documentId} archived />
      ))}
      {files.length > MAX_NUMBER_OF_FILES && (
        <ShowAllToggleElement onClick={() => setShowAll((prev) => !prev)}>
          {showAll ? (
            <>
              <ChevronUpIcon />
              See less
            </>
          ) : (
            <>
              <ChevronDownIcon />
              See more
            </>
          )}
        </ShowAllToggleElement>
      )}
    </>
  )
}

export default ArchivedFiles
